import { ScreenType } from '@accedo/one-plugin-sdk';
import { useEffect, useRef } from 'react';

import { Item, PageLayout } from '#/client/models';
import { handleScreenView } from '#/plugins/analytics/analyticsUtils';
import { FormFactors } from '#/service/constants';
import { useAuthStore } from '#/store/auth/auth.store';

interface UseSendPageScreenViewParams {
  pageLayout?: PageLayout;
  pageId?: string;
  screenType?: ScreenType;
  item?: Item;
  formFactor: FormFactors;
  screenTitle?: string;
}

export const useSendPageScreenView = ({
  pageLayout,
  pageId,
  screenType,
  item,
  formFactor,
  screenTitle,
}: UseSendPageScreenViewParams) => {
  const { isInitialised } = useAuthStore();
  const firedForPageIdRef = useRef<string | undefined>(undefined);

  // item ref avoids re-firing screen view when login/logout creates a new item reference
  const itemRef = useRef(item);
  itemRef.current = item;

  useEffect(() => {
    if (!pageLayout || !pageId || !isInitialised || firedForPageIdRef.current === pageId) {
      return;
    }

    firedForPageIdRef.current = pageId;

    const title =
      screenTitle ??
      itemRef.current?.title ??
      pageLayout.page.templates?.[formFactor]?.properties.title;

    handleScreenView({ item: itemRef.current, screenType, screenTitle: title });
  }, [pageLayout, pageId, screenType, formFactor, screenTitle, isInitialised]);
};
